import { Injectable } from "@angular/core";
import { UserSettings } from "../models/UserSettings";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, shareReplay } from "rxjs";
import { UserItem } from "../models/UserItem";
import { UserItemForEmailQuestion } from "../models/UserItemForEmailQuestion";


@Injectable({
    providedIn: 'root'
})
export class UserDataService {

    private userSettings$: Observable<UserSettings> | null = null;

    constructor(private http: HttpClient) {

    }

    getUserSettings(): Observable<UserSettings> {
        if (!this.userSettings$) {
            this.userSettings$ = this.http.get<UserSettings>('api/user/getusersettings')
                .pipe(shareReplay(1));
        }
        return this.userSettings$;
    }

    clearUserSettingsCache(): void {
        this.userSettings$ = null;
    }

    getUsers(locCode: string, considerActiveUsersOnly: boolean): Observable<UserItem[]> {
        return this.http.get<UserItem[]>(`api/user/getusers/${locCode}/${considerActiveUsersOnly}`);
    }

    getCurrentUser(): Observable<UserItem> {
        return this.http.get<UserItem>('api/user/getCurrentUser/');
    }

    getAllUsersFromSelectedRoles(roleIds: string[]): Observable<UserItemForEmailQuestion[]> {
        let params = new HttpParams();
        roleIds.forEach(roleId => {
            params = params.append('roleIds', roleId);
        });

        return this.http.get<UserItemForEmailQuestion[]>('api/user/getallusersfromallselectedroles/', {params});
    } 

    saveUserDefault(locCode: string, jsonValue: string, key: string): Observable<boolean> {
        return this.http.post<boolean>('api/user/saveuserdefault', {locCode, jsonValue, key});
    }

    getUserDefault(locCode: string, key: string): Observable<string> {
        return this.http.get<string>(`api/user/getuserdefault/${locCode}/${key}`);
    }

    clearAllUserDefaults(key: string): Observable<boolean> {
        return this.http.delete<boolean>(`api/user/clearalluserdefaults/${key}`);
    }

}